
import PeopleInsights from "../insights/PeopleInsights";

export { Page }

function Page() {
  return <PeopleInsights />;
}
